import React from 'react';

interface IErrorProps {
  children: React.ReactNode;
}

const Error: React.FC<IErrorProps> = props => {
  return <div className="error_msg">{props.children}</div>;
};

export default Error;
